import classNames from "classnames"
import React from "react"

import Typography from "./Typography"
import { Color } from "../../../constants/V2/color"

import { getAccentColor, getBackgroundColorClass } from "@utils/V2/color"

export type PriceBadgeProps = {
  text: string
  price?: string
  highlight?: string
  backgroundColor: Color.White | Color.Charcoal
  classname?: string
}

const PriceBadge = ({
  text,
  price,
  highlight,
  backgroundColor,
  classname,
}: PriceBadgeProps) => {
  const accentColor = getAccentColor(backgroundColor)

  return (
    <div
      className={classNames(
        "w-fit rounded-10 px-10 py-8",
        getBackgroundColorClass(backgroundColor),
        classname
      )}
    >
      <div className="flex gap-x-4">
        <Typography
          color={accentColor}
          text={text}
          font="grotesk"
          size="body-sm"
          weight="book"
          highlightColor={Color.Blue}
          highlightedText={highlight}
          highlightWeight="medium"
        />

        {price && (
          <Typography
            color={accentColor}
            text={price}
            font="grotesk"
            size="body-sm"
            weight="book"
            className="opacity-40"
          />
        )}
      </div>
    </div>
  )
}

export default PriceBadge
